/**
 * Pagos Recibidos / Servicio
 *
 * @author seuan
 */
import React from 'react'
import { Table, Divider, DatePicker, Button, Tooltip, Icon } from 'antd'
import numeral from 'numeral'
import moment from 'moment'
import View from '../../components/View'
import Cell from '../../components/Cell'
import Crud from '../../components/Crud'
import Api from '../../Api'
import Exception from '../../Exception'
import PagosAdjuntos from './Components/PagoAdjuntos'
import PagosDetalle from './Components/PagoDetalle'
import Colors from '../../Colors'

export default class Page extends React.Component {
  /**
 * Constructor
 *
 * @param {Object} props
 */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { width: '10%', title: 'IMPORTE', dataIndex: 'dImporte', render: value => numeral(value).format('$0,0.00') },
      { width: '5%', title: 'FIX', dataIndex: 'dTipoCambio' },
      { width: '10%', title: '# CHEQUE', dataIndex: 'sNumeroCheque' },
      { width: '10%', title: '# TRANSFERENCIA', dataIndex: 'sNumeroTransferencia' },
      { width: '10%', title: 'ESTADO', dataIndex: 'sEstado', render: status => (
        <div style={{ display: 'flex' , flexDirection: 'row', alignItems: 'center' }}>
          <Icon type={status === 'PAGADO' ? 'check' : 'clock-circle'} style={{ fontSize: 16, color: status === 'PAGADO' ? Colors.success : Colors.error }} />
            <span style={{ marginLeft: 5 }}>{status}</span>
        </div>
      )},
      // { width: '15%', title: 'FECHA REGISTRO', dataIndex: 'dKernelFechaRegistro', render: value => moment(value).format('YYYY-MM-DD HH:mm:ss') },
      { width: '10%', title: 'FECHA APLICACIÓN', dataIndex: 'dFechaPago' },
      { width: '10%', title: 'METODO', dataIndex: 'metodo.sDescripcion'},
      { width: '10%', title: 'MONEDA', dataIndex: 'moneda.sNombre'},
      { width: '15%', title: 'ACCIONES', dataIndex: 'sFolio', render: (val, record) => (
          <div>
            <Tooltip title='Adjuntos'>
              <Button
                size='small'
                shape='circle-outline'
                icon='link'
                style={{ marginRight: 7 }}
                onClick={() => this.adjuntos.load(record.iId)}
              />
            </Tooltip>
            <Tooltip title='Pagos detalle'>
              <Button
                size='small'
                shape='circle-outline'
                icon='dollar'
                style={{ marginRight: 7 }}
                onClick={() => this.detalle.load(record.iId)}
              />
            </Tooltip>
          </div>
        )
      }
    ])
    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
    }
    this.fetch = this.fetch.bind(this)
  }

  componentDidMount() {
    const fecha = moment()
    this.fetch(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * fetch
   *
   * @param {String} inicio
   * @param {String} termino
   * @param {String} search
   */
  async fetch(inicio = -1, termino = -1, search = '') {
    try {
      const fechas = {}

      if (inicio !== -1 || termino !== -1) {
        if (inicio !== 1 && termino !== -1) {
          fechas.$and = [{
            $whereFn: ['date', ['$TesPago.dKernelFechaRegistro$'], { $between: [inicio, termino] }]
          }]
        } else {
          fechas.dKernelFechaRegistro = {}
          if (inicio !== -1) {
            fechas.dKernelFechaRegistro.$gte = inicio
          }

          if (termino !== -1) {
            fechas.dKernelFechaRegistro.$lte = termino
          }
        }

      }

      this.setState({
        loading: true,
        query: { inicio, termino }
      })

      const response = await Api.query({
        attributes: [
          'iId',
          'dImporte',
          'dTipoCambio',
          'sNumeroCheque',
          'sNumeroTransferencia',
          'sEstado',
          'dKernelFechaRegistro',
          'dFechaPago'
        ],
        model: 'TesPago',
        limit: 25,
        include: [
          { as: 'metodo', attributes: ['sDescripcion'] },
          { as: 'moneda', attributes: ['sNombre'] },
          {
            as: 'cuentaProveedor',
            attributes: ['sSucursal', 'sClaveBan', 'sCuenta'],
            include: [{ as: 'banco', attributes: ['sSATNombre'] }]
          }
        ],
        where: {
          iIdProveedor: Api.getProviderId(),
          iIdRemesa: null, // todo: revisar si se mostrarán los de remesas
          iActivo: true,
          ...fechas,
        },
        order: [['iId', 'DESC']]
      })

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        //lookup: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }
   /**
   * Render
   */
  render() {
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={() =>
          this.fetch(
            this.state.inicio,
            this.state.termino,
          )
        }
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.fetch(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
              )
          }
        />
        <Divider type='vertical' />
        {crud}
        <Divider type='vertical'/>
      </div>

    )

    return (
      <View>
        <PagosAdjuntos
          ref={ref => this.adjuntos = ref}
        />
        <PagosDetalle
          ref={ref => this.detalle = ref}
        />
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1 style={{ margin: 0 }}>Pagos programados</h1>
          <label>SEGUIMIENTO DE PAGOS PROGRAMADOS Y APLICADOS</label>
          <br />

          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={this.state.data}
            columns={this.columns}
            loading={this.state.loading}
            pagination={{ pageSize: 35 }}
            title={() => tableTitle}
          />
        </div>
      </View>
    )
  }
}
